import React from 'react'
import PropTypes from 'prop-types'
import Carousel from 'nuka-carousel'
import { formatAddress, croppedImg } from 'utils'
import GetDirections from 'components/GetDirections'
import { triggerEvent } from 'utils'
// import Lightbox from 'react-image-lightbox';

class CellarLocation extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      selectedImage: 0,
      isOpen: false,
    }
  }

  openLightbox(selectedImage) {
    this.setState({
      selectedImage,
      isOpen: true,
    })
  }

  render() {
    const { location } = this.props
    // const { selectedImage, isOpen } = this.state;

    if (
      window.firstAccessQueryString.showLocation &&
      location._id !== window.firstAccessQueryString.showLocation
    ) {
      return null
    }

    const images = []
    const imagesItems = [location.mainImage].concat(location.galleryImages).map((imgSrc, i) => {
      const src = croppedImg(imgSrc, 1000, 500)
      images.push(src)
      return (<img
        key={i}
        src={src}
        onLoad={() => triggerEvent(window, 'resize')}
        // onClick={() => {
        //   this.openLightbox(i);
        // }}
      />)
    })

    return (
      <div className="space--bottom-3">
        <div className="location-box">
          <div className="grid">
            <div className="grid__item lap-6-12">
              <Carousel>
                {imagesItems}
              </Carousel>
              {/* {
                isOpen &&
                <Lightbox
                  mainSrc={images[selectedImage]}
                  nextSrc={images[(selectedImage + 1) % images.length]}
                  prevSrc={
                    images[(selectedImage + images.length - 1) % images.length]
                  }
                  onCloseRequest={() => this.setState({ isOpen: false })}
                  onMovePrevRequest={() => this.setState({
                    selectedImage: (selectedImage + images.length - 1) % images.length,
                  })}
                  onMoveNextRequest={() => this.setState({
                    selectedImage: (selectedImage + 1) % images.length,
                  })}
                />
              } */}
            </div>
            <div className="grid__item lap-6-12">
              <div className="location-box__content">
                <h3 className="location-box__content__title gamma">
                  {location.title}
                </h3>
                <p className="location-box__content__address">
                  {formatAddress(location.address)}
                </p>
                <GetDirections
                  coords={location.address.coords}
                />
                <p
                  className="location-box__content__description"
                  dangerouslySetInnerHTML={{
                    __html: location.description,
                  }}
                >
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

CellarLocation.propTypes = {
  location: PropTypes.object.isRequired,
}

export default CellarLocation
